import { render, staticRenderFns } from "./UiSlidingIndicator.vue?vue&type=template&id=29d89116"
import script from "./UiSlidingIndicator.vue?vue&type=script&lang=js"
export * from "./UiSlidingIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports